module.exports = __webpack_public_path__ + "static/Museo-e4807bdb3b64e0f32c8f05f4dc9e6fea.jpg";